import { EKwikUIInputFileSize } from "./input-files.definitions";

export const DEFAULT_VALUES = {
  accept: "application/pdf",
  class: "",
  disabled: false,
  formControlName: "form_control_input_files",
  icon: "tuiIconUploadLarge",
  id: "input_files",
  label: "or drop it here",
  link: "Choose a file",
  maxFileSize: 10000000,
  multiple: false,
  setFileTypesToForm: ["NORMAL", "ERROR", "LOADING", "DELETED"],
  showAddedFiles: true,
  size: EKwikUIInputFileSize.M,
  styles: "",
  showViewButton: false,
  variant: "native"
};

export const VALIDATE_KEY_VALUES = {
  accept: true,
  class: false,
  disabled: true,
  formControlName: true,
  icon: true,
  id: true,
  label: true,
  link: true,
  maxFileSize: true,
  multiple: true,
  setFileTypesToForm: false,
  showAddedFiles: true,
  size: true,
  styles: false,
  variant: true
};
